import * as React from 'react';
interface ICrossA {
    style?: {}; // inline style obj
    color?: string; // #000000
}
const CrossA: React.FC<ICrossA> = (props) => {
    const { color } = props;
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <defs>
                <path
                    d="M8 0a8 8 0 11-.001 16.001A8 8 0 018 0zm0 1.334A6.674 6.674 0 001.334 8 6.674 6.674 0 008 14.666 6.674 6.674 0 0014.666 8 6.674 6.674 0 008 1.334zM6.004 5.148L8 7.145l1.996-1.997.856.857L8.857 8l1.995 1.995-.856.856-1.995-1.995-1.996 1.996-.857-.856 1.997-1.996-1.997-1.997.856-.856z"
                    id="CrossA_a"
                />
            </defs>
            <use fill={color} fillRule="nonzero" xlinkHref="#CrossA_a" />
        </svg>
    );
};

export default CrossA;
